export default from './notifications-settings';



// WEBPACK FOOTER //
// ./app/components/notifications-settings/index.js